import { StorageV2Translations } from "../../../pt-BR/place/storage/storage-v2";

const productsTable: StorageV2Translations["tabs"]["products"]["table"] = {
	columns: {
		product: "Product",
		fiscalCode: "SKU",
		category: "Category",
		categoryFilterButton: "Filter by category {{categoryName}}",
		quantity: "Quantity",
		lastUnitCost: "Last cost",
		avgUnitCost: "Average cost",
		totalAvgCost: "Total cost",
		actions: {
			seeProductDetails: "See product details",
			transferProduct: "Transfer product",
			removeProduct: "Remove product",
			ariaLabels: {
				button: "Actions for product {{productName}}",
				details: "See details for product {{productName}}",
				transfer: "Transfer product to another storage",
				remove: "Remove product from storage",
			},
		},
	},
	quantityInput: {
		add: "Add quantity for {{productName}}",
		remove: "Remove quantity for {{productName}}",
		cannotRemove: "It is not possible to remove quantity because the product is zero",
	},
};

const addStorageProductDrawer: StorageV2Translations["tabs"]["products"]["addStorageProductDrawer"] = {
	title: "Add product",
	successMessage: "Product added successfully!",
	errorMessage: "Error adding product to storage.",
	form: {
		product: "Product",
		productPlaceholder: "Select product",
		quantity: "Quantity",
		unitCostValue: "Unit cost",
		unitCostValueType: "Value by",
		totalCostValue: "Total cost",
		costValueByUnit: "Cost by {{unit}}",
		validation: {
			productIsRequired: "Select a product",
			quantityMustBeGreaterThanZero: "Quantity must be greater than zero",
			invalidQuantity: "Invalid quantity",
			maxValue: "Maximum value is {{maxValue}}",
		},
		actions: {
			cancel: "Cancel",
			add: "Add product",
		},
	},
};

const importInvoiceDrawer: StorageV2Translations["tabs"]["products"]["importInvoiceDrawer"] = {
	title: "Import invoice",
	errorMessage: "Error importing invoice.",
	content: {
		title: "Import invoice XML",
		subtitle: "Upload XML of purchase invoice",
	},
	validation: {
		xmlRequired: "The XML file is required.",
	},
	upload: {
		dropzoneTitle: "Drag and drop the file here",
		dropzoneSubtitle: "or click to select the file",
		fileDetails: "XML File",
		uploadErrorMessage: "Could not read the file.",
		invalidFileTitle: "Invalid file",
		invalidFileReasonDefault: "The selected file is invalid.",
		invalidFileReasonInvalidType: "Invalid format. Accepted formats: {{formats}}",
	},
	actions: {
		cancel: "Cancel",
		import: "Import",
	},
};

const adjustStorageProductDrawer: StorageV2Translations["tabs"]["products"]["adjustStorageProductDrawer"] = {
	input: {
		title: "Add quantities to product {{productName}}",
	},
	remove: {
		title: "Remove quantities from product {{productName}}",
	},
	form: {
		product: "Product",
		addQuantity: "Quantity you want to add",
		removeQuantity: "Quantity you want to remove",
		unitCostValue: "Unit cost value",
		validation: {
			quantityMustBeGreaterThanZero: "The quantity must be greater than zero",
			invalidQuantity: "Invalid quantity",
			maxValue: "The maximum quantity is {{maxValue}}",
		},
		actions: {
			cancel: "Cancel",
			add: "Add quantity",
			remove: "Remove quantity",
		},
		productionRuleWarning: {
			title: "Attention",
			description:
				"This product has a technical sheet and its items will be reduced from stock only when they are with no stock.",
		},
	},
	notifications: {
		success: {
			input: "Quantities added successfully",
			remove: "Quantities removed successfully",
		},
		error: {
			input: "Error adding quantities",
			remove: "Error removing quantities",
		},
	},
};

export const storageV2: StorageV2Translations = {
	backButtonLabel: "Back to storages",
	tabs: {
		products: {
			title: "Products in stock",
			header: {
				filters: {
					search: {
						placeholder: "Search for product",
					},
					category: {
						placeholder: "Filter by category",
						all: "All categories",
					},
					state: {
						placeholder: "Filter by stock state",
						all: "All products",
						zero: "Zero stock",
						negative: "Negative stock",
					},
				},
				actions: {
					inventory: "Inventory stock",
					inventoryTitle: "Inventory stock",
					addProducts: "Add products",
					addProductsTitle: "Add products to stock",
					importXml: "Import XML",
					importXmlTitle: "Import XML from purchase invoice",
					importViaExcel: "Import via Excel",
					importViaExcelTitle: "Import via Excel",
				},
			},
			totalizers: {
				productsInStock: "Products in stock",
				totalCost: "Total cost",
				productsWithoutCost: "Products without cost",
				productsWithoutStock: "Products without stock",
				seeProducts: "See products",
			},
			table: productsTable,
			addStorageProductDrawer,
			importInvoiceDrawer,
			adjustStorageProductDrawer,
			adjustProductUnitCostValue: {
				label: "Update unit cost value of {{productName}}",
				disabledLabel:
					"Unit cost value of {{productName}} cannot be updated, because product does not have stock",
			},
			transferDrawer: {
				title: "Transfer product from stock {{productName}}",
				form: {
					label: {
						product: "Product",
						fromStorage: "Removing products from stock",
						toStorage: "Transferring products to stock",
						quantity: "Quantity to transfer",
					},
					placeholder: {
						toStorage: "Select stock",
					},
					hint: {
						maxQuantity: "Maximum available: {{maxQuantity}}",
					},
					sectionTitle: {
						chooseDestination: "Choose the destination storage",
					},
					validation: {
						maxStorageCountIs: "Maximum stock quantity is {{productMaxCountString}}",
						missingField: "Mandatory field",
						invalidQuantity: "Invalid quantity",
					},
				},
				actions: {
					cancel: "Cancel",
					submit: "Complete transfer",
				},
				notifications: {
					success: "Transfer completed successfully.",
				},
			},
			removeProductFromStorageDialog: {
				title: "Remove product",
				warningMessageSingle:
					"Are you sure you want to remove the product {{productName}} from stock?",
				warningMessageMultiple:
					"Are you sure you want to remove the {{count}} products from stock?",
				warningMessageStrong: " This action cannot be undone",
				submit: "Remove product",
				notifications: {
					success: "Product removed from stock successfully.",
				},
			},
		},
		inventory: {
			title: "Inventory history",
		},
	},
};
